export default {
  baseStyle: {
    borderColor: "inactive",
  },
};
